import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap, takeUntil, tap, withLatestFrom } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';

import * as AuthActions from '../actions/auth.actions';
import * as StartActions from '../actions/start.actions';
import { AuthService } from '../../services/auth.service';
import { getToken } from '../selectors/auth.selectors';
import { environment } from '../../../environments/environment';
import { CookieConfig } from '../../../config/cookie-config';

@Injectable()
export class AuthEffects {

  retrieveMeInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.meRetrieve),
      switchMap(() =>
        this.authService.me().pipe(
          takeUntil(this.actions$.pipe(ofType(StartActions.cancelInit))),
          map((account) => AuthActions.meSuccess({ user: {...account } })),
          catchError((error) => of(AuthActions.meFailure({error})))
        )
      )
    )
  );

  retrieveAccountInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.accountRetrieve),
      switchMap(() =>
        this.authService.me().pipe(
          map((account) => {
            return AuthActions.accountSuccess({ account });
          }),
          catchError((error) =>
            of(AuthActions.accountFailure({ error }))
          )
        )
      )
    )
  );

  setActiveAccount$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.setActiveBusiness),
      withLatestFrom(this.store.select(getToken)),
      switchMap(([{ businessId, businessType }, token]) => {
        this.cookieService.set(environment.COOKIE_BID, businessId, CookieConfig.getExpireDate(), '/', environment.COOKIE_DOMAIN, true);
        this.cookieService.set(environment.COOKIE_BT, businessType, CookieConfig.getExpireDate(), '/', environment.COOKIE_DOMAIN, true);
        return of(AuthActions.meRetrieve({ token }));
      })
    )
  );

  meFailure$ = createEffect(() => {
      return inject(Actions).pipe(
        ofType(AuthActions.meFailure),
        tap(() => {
          this.authService.logout();
        }));
    }, {functional: true, dispatch: false}
  );

  constructor(
    private actions$: Actions,
    private authService: AuthService,
    private cookieService: CookieService,
    private store: Store,
  ) { }
}
